import { Box, Link, Image, Flex } from "@chakra-ui/react";
import React from "react";
import GitHubCalender from "react-github-calendar";
import ReactTooltip from "react-tooltip";
import "./github.css";

const Github = () => {

       const selectLastHalfYear = (contributions) => {
         const currentYear = new Date().getFullYear();
         const currentMonth = new Date().getMonth();
         const shownMonths = 10;

         return contributions.filter((day) => {
           const date = new Date(day.date);
           const monthOfDay = date.getMonth();

           return (
             date.getFullYear() === currentYear &&
             monthOfDay > currentMonth - shownMonths &&
             monthOfDay <= currentMonth
           );
         });
       };

  return (
    <section className="github__container section" id="github">
      <Box
        textAlign={"center"}
        w={{ lg: "100%", md: "100%", sm: "100%", base: "100%" }}
        m={"auto"}
        mb={10}
      >
        <h2 className="section__title">My Github Statistics</h2>
        <div className="calender__container container ">
          <Box
            m={"auto"}
            mt={5}
            w={{ lg: "90%", md: "90%", sm: "100%", base: "100%" }}
          >
            <Link href="https://github.com/isky27" isExternal>
              <GitHubCalender
                username="isky27"
                // transformData={selectLastHalfYear}
                blockSize={15}
                fontSize={22}
                hideColorLegend
                hideTotalCount
              >
                <ReactTooltip delayShow={20} html />
              </GitHubCalender>
            </Link>
          </Box>
          <Box m={"auto"} w={"full"} mt={7}>
            <Link href="https://github.com/isky27" isExternal>
              <Image
                m={"auto"}
                w={{ lg: "60%", md: "70%", sm: "90%" }}
                src="https://github-readme-streak-stats.herokuapp.com?user=isky27"
                alt="Github Statistics"
              />
            </Link>
          </Box>
          <Flex
            w={"full"}
            m="auto"
            mt={7}
            gap={4}
            flexDirection={{ lg: "row", sm: "column", base: "column" }}
            justifyContent={"space-around"}
          >
            <Link m={"auto"} href="https://github.com/isky27" isExternal>
              <Image
                align="center"
                src="http://github-profile-summary-cards.vercel.app/api/cards/stats?username=isky27&theme=nord_bright" //launguages
              />
            </Link>
            <Link m={"auto"} href="https://github.com/isky27" isExternal>
              <Image
                align="center"
                src="http://github-profile-summary-cards.vercel.app/api/cards/repos-per-language?username=isky27&theme=nord_bright" //stats
              />
            </Link>
          </Flex>
        </div>
      </Box>
    </section>
  );
};

export default Github;
